(() => {
  const root = window.Shopify?.routes?.root || '/';
  const theme = new URL(location.href).searchParams.get('preview_theme_id') || document.body.dataset.flPreview;
  const url = (offer) => {
    const u = new URL(root, location.origin);
    if (offer) u.searchParams.set('view', 'florelle-offer');
    if (theme) u.searchParams.set('preview_theme_id', theme);
    return u.pathname + u.search;
  };
  function init() {
    document.querySelectorAll('[data-fl-offer]').forEach(a => a.href = url(true));
    document.querySelectorAll('[data-fl-home]').forEach(a => { const hash = new URL(a.href).hash; a.href = url(false) + hash; });
    document.querySelectorAll('[data-fl-countdown]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      if (bar.dataset.preview) return;
      const deadline = Date.parse(bar.dataset.deadline);
      if (!Number.isFinite(deadline)) { bar.hidden = true; return; }
      const tick = () => {
        const remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        if (!remaining) { bar.hidden = true; return false; }
        [['hours', Math.floor(remaining / 3600)], ['minutes', Math.floor(remaining % 3600 / 60)], ['seconds', remaining % 60]].forEach(([key,value]) => { bar.querySelector('[data-fl-'+key+']').textContent = String(value).padStart(2,'0'); });
        return true;
      };
      if (tick()) { const interval = setInterval(() => { if (!bar.isConnected || !tick()) clearInterval(interval); },1000); }
    });
    document.querySelectorAll('[data-fl-carousel]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const slides = [...gallery.querySelectorAll('[data-fl-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-fl-thumb]')];
      let current = 0;
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide,i) => { slide.hidden = i !== current; });
        thumbs.forEach((thumb,i) => { thumb.classList.toggle('is-active',i===current); thumb.setAttribute('aria-pressed',String(i===current)); });
        gallery.querySelector('[data-fl-gallery-count]').textContent = (current+1)+' / '+slides.length;
      };
      thumbs.forEach((button,i) => button.addEventListener('click',()=>show(i)));
      gallery.querySelector('[data-fl-prev]').addEventListener('click',()=>show(current-1));
      gallery.querySelector('[data-fl-next]').addEventListener('click',()=>show(current+1));
      gallery.addEventListener('keydown',event => { if (event.key==='ArrowRight' || event.key==='ArrowLeft') { event.preventDefault(); show(current+(event.key==='ArrowRight'?1:-1)); } });
      let touchStart;
      const stage = gallery.querySelector('.fl-gallery-stage');
      stage.addEventListener('touchstart',event => { touchStart = event.changedTouches[0].clientX; },{passive:true});
      stage.addEventListener('touchend',event => { const delta = event.changedTouches[0].clientX-touchStart; if (Math.abs(delta)>45) show(current+(delta<0?1:-1)); },{passive:true});
    });
    document.querySelectorAll('[data-fl-review-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-fl-review-track]');
      const cards = [...carousel.querySelectorAll('[data-fl-review-card]')];
      const count = carousel.querySelector('[data-fl-review-count]');
      const step = () => cards[0].getBoundingClientRect().width + 16;
      const current = () => Math.max(0,Math.min(cards.length-1,Math.round(track.scrollLeft/step())));
      const updateCount = index => { const active = index ?? current(); count.textContent = (active+1)+' / '+cards.length; };
      const move = direction => {
        const target = Math.max(0,Math.min(cards.length-1,current()+direction));
        updateCount(target);
        track.scrollTo({left:target*step(),behavior:'smooth'});
      };
      carousel.querySelector('[data-fl-review-prev]').addEventListener('click',()=>move(-1));
      carousel.querySelector('[data-fl-review-next]').addEventListener('click',()=>move(1));
      track.addEventListener('scroll',()=>requestAnimationFrame(()=>updateCount()),{passive:true});
      track.addEventListener('keydown',event => { if (event.key==='ArrowRight' || event.key==='ArrowLeft') { event.preventDefault(); move(event.key==='ArrowRight'?1:-1); } });
      updateCount();
    });
    const el = document.querySelector('[data-fl-offer-root]');
    if (!el || el.dataset.ready) return;
    el.dataset.ready = 'true';
    const t = JSON.parse(el.querySelector('[data-fl-translations]').textContent);
    const allocations = JSON.parse(el.querySelector('[data-fl-allocations]')?.textContent || '{}');
    const nativeForm = el.querySelector('[data-fl-native-form]');
    let syncingVariant = false;
    const fmt = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(cents/100);
    const text = (key, vars) => t[key].replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? '');
    let selected;
    const update = () => {
      const subscription = el.querySelector('[name="fl-purchase"]:checked').value === 'subscription';
      const chosenNativePlan = nativeForm?.querySelector('[name="selling_plan"]')?.value || '';
      el.querySelectorAll('.fl-upgrade').forEach(row => { row.hidden = !subscription; });
      el.querySelectorAll('[data-fl-card]').forEach(card => {
        const count = Number(card.dataset.jars);
        card.hidden = false;
        const variantId = card.querySelector('input').value;
        const variantPlans = allocations[variantId] || [];
        const allocation = chosenNativePlan ? variantPlans.find(a => a.id === chosenNativePlan) : variantPlans[0];
        card.dataset.plan = allocation?.id || '';
        card.dataset.planName = allocation?.name || '';
        const cents = subscription
          ? (allocation?.price ?? Number(card.dataset.sub))
          : (count === 1 ? Number(el.dataset.oneTimePrice) : Number(card.dataset.oneTimePrice));
        card.querySelector('[data-fl-unit]').textContent = fmt(cents/count);
        card.querySelector('[data-fl-card-total]').textContent = fmt(cents);
        const checked = card.querySelector('input').checked;
        card.classList.toggle('is-selected', checked);
        if (checked) selected = {card, cents, base:Number(card.dataset.base), count, subscription, variant:(!subscription && count === 1) ? el.dataset.oneTimeVariant : card.querySelector('input').value, plan:subscription ? card.dataset.plan : '', planName:subscription ? card.dataset.planName : ''};
      });
      const nativeVariant = nativeForm?.querySelector('[data-fl-native-variant]');
      if (nativeVariant && nativeVariant.value !== selected.variant) {
        syncingVariant = true;
        nativeVariant.value = selected.variant;
        nativeVariant.dispatchEvent(new Event('change',{bubbles:true}));
        syncingVariant = false;
      }
      const vars = {jars:selected.count === 1 ? "1 jar" : selected.count + " jars", total:fmt(selected.cents), plan:selected.planName};
      el.querySelector('[data-fl-count]').textContent = selected.count;
      el.querySelector('[data-fl-summary-frequency]').textContent = subscription && selected.plan ? selected.planName : text(subscription ? 'subscriptionSummary' : 'oneTimeSummary',vars);
      ['summary-price','subtotal'].forEach(k => el.querySelector('[data-fl-'+k+']').textContent = vars.total);
      const shipping = selected.count === 1 ? 495 : 0;
      el.querySelector('[data-fl-shipping]').textContent = shipping ? fmt(shipping) : t.freeShipping;
      el.querySelector('[data-fl-total]').textContent = fmt(selected.cents + shipping);
      const hasBundleGifts = selected.count > 1;
      el.querySelectorAll('[data-fl-gift-shipping], [data-fl-gift-mystery]').forEach(g => {
        g.classList.toggle('is-on',hasBundleGifts);
        const ribbon=g.querySelector('[data-fl-gift-lock]');
        if(ribbon) ribbon.textContent=hasBundleGifts ? t.giftUnlocked : t.giftLocked;
      });
      el.querySelector('[data-fl-gift-counter]').textContent = hasBundleGifts ? t.giftBundledDisplay : t.giftSingleDisplay;
      el.querySelector('[data-fl-gift-meter]').style.width = hasBundleGifts ? '100%' : '33%';
      el.querySelector('[data-fl-gift-note]').textContent = hasBundleGifts ? t.bundleGiftNote : t.singleGiftNote;
      el.querySelector('[data-fl-checklist-shipping]').textContent = shipping ? t.singleShippingLabel : t.bundleShippingLabel;
      el.querySelector('[data-fl-renewal]').textContent = subscription ? (selected.plan ? selected.planName : text('renewal',vars)) : '';
      el.querySelector('[data-fl-plan-notice]').hidden = !subscription || Boolean(selected.plan);
      el.querySelector('[data-fl-status]').textContent = subscription && !selected.plan ? t.noPlan : (el.dataset.enabled === 'true' ? t.ready : t.draft);
      el.querySelector('[data-fl-terms]').textContent = text(subscription ? (selected.plan ? 'planTerms' : 'subscriptionTerms') : 'oneTimeTerms',vars);
      const discount = Math.max(0,Math.round((1-selected.cents/selected.base)*100));
      el.querySelector('[data-fl-checkout-label]').textContent = subscription ? text('checkoutDiscount',{discount}) : t.checkoutOneTime;
    };
    el.addEventListener('change',event => {
      if (syncingVariant) return;
      if (event.target.name === 'fl-purchase') {
        const preferred = event.target.value === 'subscription' ? 3 : 1;
        const match = el.querySelector('[data-fl-card][data-jars="'+preferred+'"] input');
        if (match) match.checked = true;
      }
      if (event.target.closest('[data-fl-native-form]') && event.target.name === 'selling_plan') {
        const mode = event.target.value ? 'subscription' : 'one-time';
        el.querySelector('[name="fl-purchase"][value="'+mode+'"]').checked = true;
      }
      update();
    });
    update();
    const button = el.querySelector('[data-fl-checkout]');
    const status = el.querySelector('[data-fl-status]');
    button.addEventListener('click', async () => {
      if (el.dataset.enabled !== 'true') {status.textContent=t.draft;status.classList.add('fl-status-notice');return;}
      if (selected.subscription && !selected.plan) {status.textContent=t.noPlan;return;}
      if (!/^\d+$/.test(selected.variant)) {status.textContent=t.unavailable;return;}
      // Shopify checkout should receive actual $0 gift product lines, not only cart notes.
      const item = {id:Number(selected.variant),quantity:1};
      if (selected.count > 1) {
        item.properties = {
          'Bonus jars included': selected.count === 3 ? '1 complimentary jar' : '2 complimentary jars'
        };
      }
      if (selected.subscription) item.selling_plan = Number(selected.plan);
      const giftVariantIds = {
        guarantee:Number(el.dataset.flGiftGuaranteeVariant),
        shipping:Number(el.dataset.flGiftShippingVariant),
        mystery:Number(el.dataset.flGiftMysteryVariant)
      };
      const giftTypes = selected.count > 1 ? ['guarantee','shipping','mystery'] : ['guarantee'];
      const giftItems = giftTypes.map(type => {
        const id = giftVariantIds[type];
        if (!Number.isSafeInteger(id) || id <= 0) throw new Error('Gift item unavailable');
        return {
          id,quantity:1,
          properties: {
            '_Florelle gift': type,
            '_Bundle': selected.count + ' jar' + (selected.count === 1 ? '' : 's'),
            '_First delivery only': 'Yes'
          }
        };
      });
      button.disabled = true;
      status.textContent = t.loading;
      try {
        // Replace only prior Florelle items/gifts, never unrelated shopping-cart products.
        const cartResponse = await fetch(root+'cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin',cache:'no-store'});
        if (!cartResponse.ok) throw new Error('Unable to inspect cart');
        const cart = await cartResponse.json();
        const managedVariantIds = new Set([
          Number(el.dataset.oneTimeVariant),
          ...[...el.querySelectorAll('[data-fl-card] input[name="fl-bundle"]')].map(input=>Number(input.value)),
          ...Object.values(giftVariantIds)
        ]);
        const updates = {};
        (cart.items || []).forEach(line => {
          if (managedVariantIds.has(Number(line.id))) updates[String(line.key)] = 0;
        });
        if (Object.keys(updates).length) {
          const cleanup = await fetch(root+'cart/update.js',{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            credentials:'same-origin',body:JSON.stringify({updates})
          });
          if (!cleanup.ok) throw new Error('Unable to replace prior Florelle selection');
        }
        const response = await fetch(root+'cart/add.js',{
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',body:JSON.stringify({items:[item,...giftItems]})
        });
        if (!response.ok) {
          const failure = await response.json().catch(()=>({}));
          throw new Error(failure.description || 'Cart rejected');
        }
        location.assign(root+'checkout');
      } catch (error) {
        console.error('Florelle checkout:',error);
        status.textContent=t.error;
        button.disabled=false;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',event => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-fl-checkout]').forEach(button => { button.disabled = false; });
    document.querySelectorAll('[data-fl-offer-root] [name="fl-purchase"]:checked').forEach(input => input.dispatchEvent(new Event('change')));
  });
})();
